module.exports = __webpack_public_path__ + "img/xxyj_n.d0deee82.png";